const stringMixin = {
  methods: {
    copyToClipboard (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    },
    getRandomPassword () {
      return Math.floor(Math.random() * Math.pow(10, 16)).toString().padStart(16, '0')
    },
    isJSON (str) {
      try {
        return (JSON.parse(str) && !!str)
      } catch (e) {
        return false
      }
    },
  },
}

export default stringMixin
